/* Exclusivity by Addicted Bespoken — progressive-enhancement effects.
   The page works fully without this file; it only adds a soft fade-in
   as sections enter the viewport. Safe to remove. */
(function () {
  "use strict";

  var sections = document.querySelectorAll(".abx .sec, .abx .hero, .abx .strip");
  if (!sections.length) return;

  if (!("IntersectionObserver" in window) ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return; // leave everything fully visible, no animation
  }

  sections.forEach(function (el) {
    el.style.opacity = "0";
    el.style.transform = "translateY(18px)";
    el.style.transition = "opacity .7s ease, transform .7s ease";
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = "1";
          entry.target.style.transform = "translateY(0)";
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
  );

  sections.forEach(function (el) {
    io.observe(el);
  });
})();
